<template>
  <div class="diadin">
 
    

    <div style="display: flex;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input style="width: 300px;" clearable
            :placeholder="$t('menu.uesr')"
            v-model="formInline.searchKey"></el-input>
        </el-form-item>
      
       

        <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
      </el-form>
    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row height="600">
      <!-- <el-table-column prop="entityId" label="账户编码" ></el-table-column> -->
      <el-table-column prop="entityName" :label="$t('menu.uesr')" > 
         <!-- <template slot-scope="scope">
          <div>
            {{pdlsh(scope.row.entityTypeId)}}   {{pdlsha(scope.row.entityTypeId)}}
          </div>
        </template> -->
        
      </el-table-column>
      
      <el-table-column prop="accTypeId" :label="$t('menu.zhgllx')" >
         <template slot-scope="scope">
          <div>
            {{flstusts(scope.row.accTypeId)}}
          </div>
        </template>
        
      </el-table-column>
      <el-table-column prop="accountBalance" :label="$t('menu.zhglyem')" ></el-table-column>
        <el-table-column prop="discountRate" :label="$t('menu.xiaddanzhoukbil')" >
         <template slot-scope="scope">
          <div>
            {{scope.row.discountRate}}%
          </div>
        </template>
        
      </el-table-column>
      <el-table-column prop="" :label="$t('menu.Operation')">
        <template slot-scope="scope">
           <el-button type="text" size="mini"  @click="lishuidio(scope.row.id)" >{{ $t('menu.zhglls') }}</el-button>
         <el-button type="text" size="mini"  @click="tzdio(scope.row)" >{{ $t('menu.yuetiaozheng') }}</el-button>
          <el-button type="text" size="mini"  @click="shezhib(scope.row)" >{{ $t('menu.shezhi') }}</el-button>
        </template>
      </el-table-column>

    </el-table>
      <el-dialog
       :title="$t('menu.yuetiaozheng')"
      
       :visible.sync="dialogye"
       width="300"
       > 
      <div style="width: 100%;">
        <!-- <div style="display: flex;margin-bottom: 10px;align-items: center;">
          <div style="width: 100px;text-align: right;margin-right: 10px;">
            <span style="color: red;">*</span>
           {{ $t('menu.Type') }}
          </div>
          <el-radio v-model="jsdata.transactionCategory" label="1"> {{ $t('menu.zengjia') }}</el-radio>
          <el-radio v-model="jsdata.transactionCategory" label="-1"> {{ $t('menu.jiankou') }}</el-radio>
        </div> -->
         <div style="display: flex;margin-bottom: 10px;align-items: center;">
          <div style="width: 100px;text-align: right;margin-right: 10px;">
            <span style="color: red;">*</span>
                {{ $t('menu.TransactionType') }}
          </div>
             <el-select style="width: 200px;" v-model="jsdata.transactionTypeId" placeholder="">
    <el-option
      v-for="item in accTransactionTypeList"
      
      v-if="item.accTypeId==accTypeIds&&item.name=='零售商售后账户充值'"
      :key="item.id"
      :label="in8l=='zh'?item.name:item.nameEn"
      :value="item.id">
    </el-option>
    <el-option
      v-for="item in accTransactionTypeList"
      
      v-if="item.accTypeId==accTypeIds&&item.name=='零售商售后账户扣款'"
      :key="item.id"
      :label="in8l=='zh'?item.name:item.nameEn"
      :value="item.id">
    </el-option>
    <el-option
      v-for="item in accTransactionTypeList"
      
      v-if="item.accTypeId==accTypeIds&&item.name=='零售商整车补贴账户充值'"
      :key="item.id"
      :label="in8l=='zh'?item.name:item.nameEn"
      :value="item.id">
    </el-option>
    <el-option
      v-for="item in accTransactionTypeList"
      
      v-if="item.accTypeId==accTypeIds&&item.name=='零售商整车补贴账户扣款'"
      :key="item.id"
      :label="in8l=='zh'?item.name:item.nameEn"
      :value="item.id">
    </el-option>
  </el-select>
        </div >
       
       
      
         <div style="display: flex;margin-bottom: 10px;align-items: center;">
          <div style="width: 100px;text-align: right;margin-right: 10px;">
            <span style="color: red;">*</span>
         {{ $t('menu.Amount') }}
          </div>
           <el-input
           style="width: 200px;"
             v-model="jsdata.amount">
       </el-input>
        </div>
         <div style="display: flex;margin-bottom: 10px;">
          <div style="width: 100px;text-align: right;margin-right: 10px;">
          {{ $t('menu.Remarks') }}
           
          </div>
          <el-input
             type="textarea"
             :rows="2" 
             style="width: 400px;"
             v-model="jsdata.comment">
       </el-input>
        </div>
           <div style=" margin: 30px auto;width: fit-content;display: flex;">
          <el-button  type="primary" @click="jzup"
            class="er">{{ $t('menu.Confirm') }}</el-button>
        <el-button   @click="qxsc"
            class="er"> {{ $t('menu.Cancel') }}</el-button>

        </div>
      </div>
    </el-dialog>
    
     <el-dialog
       :title="$t('menu.shezhi')"
      
       :visible.sync="ddiaoloshe"
       width="400px"
       >
      <div style="margin-bottom: 10px;">
        {{$t('menu.xiaddanzhoukbil')  }}
      </div>
       <div style="display: flex;align-items: center;">
         <el-input style="width: 300px;" clearable
            
            v-model="bl"></el-input>
          <div style="font-size: 15px;margin-left: 5px;">
             %
          </div>
       </div>
       <div style=" margin: 30px auto;width: fit-content;display: flex;">
          <el-button  type="primary" @click="szcg"
            class="er">{{ $t('menu.Confirm') }}</el-button>
        <el-button   @click="qxsc"
            class="er"> {{ $t('menu.Cancel') }}</el-button>

        </div>
    </el-dialog>
    <el-dialog
       :title="$t('menu.zhglls')"
        @close="clos"
       :visible.sync="dialogVisible"
       v-if="dialogVisible"
       width="70%"
       >
    <compont :accTypeId="accTypeId"  ref="comid1"></compont>
    </el-dialog>

  </div>
</template>

<script>
import {  myAccLis, listAccType,listAccTransactionType,jzbook,shezhilzekk,retailerlist } from "../../api/api";
import compont from "./compont.vue";
export default {
  components:{
    "compont":compont
  },
  data () {
    return {
      myAcclist: [],
      accTypeId: 11,
      action: 0,
      accTypeIds:'',
      dialogVisible:false,
      ddiaoloshe:false,
      bl:0,
    blid:'',
   dialogye:false,
      mation: [], //列表
      formInline: {
        searchKey: "",
      
      },
      accTypeList: [],
      jsdata:{
        accId:'',
        transactionTypeId:'',
        // transactionCategory:'1',
        comment:'',
        amount:'',
      },
      value1: '',
      lslis:[],
      in8l: 'zh',
      accTransactionTypeList:[],
    };
  },

  created () {
    let a = sessionStorage.getItem('i18n')
    this.in8l = a
    this.biao();
    this.getTypeList()
    this.getListAccTransactionType()
    this.lsslist()
  },
  methods: {
     pdlsh(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerName
          }
      })
      return c 
    },
      async lsslist(){
      
        let param = new URLSearchParams()
      const { data: res } = await retailerlist(param, 1,500)
      console.log(res.rows);
    this.lslis=res.rows
      
    },

     pdlsha(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerNameFull
          }
      })
      return c 
    },




   lishuidio(e){
    this.accTypeId=''
     this.accTypeId=e
    this.dialogVisible=true

   },
   clos(){
     this.accTypeId=''
   
    this.dialogVisible=false
   },
  async szcg(){
  
     let param = new URLSearchParams();
      const { data: res } = await shezhilzekk(
        param,
         this.blid,
        this.bl
        
      );
      console.log(res);
      if(res.code==200){
this.$message.success('调整成功')
this.qxsc()
this.biao()
      }else{
       this.$message.error(res.msg)
      }
   },
   qxsc(){
     this.dialogye=false
     this.ddiaoloshe=false
      this.bl=0
    this.blid=''
   },
   shezhib(e){
    this.ddiaoloshe=true
    this.bl=e.discountRate
    this.blid=e.id
   },
   tzdio(e){
    this.dialogye=true
    this.jsdata={
        accId:e.id,
        transactionTypeId:'',
        // transactionCategory:'1',
        comment:'',
        amount:'',
    }
    this.accTypeIds=e.accTypeId
   },
  async jzup(){
    
     let param = new URLSearchParams();
      const { data: res } = await jzbook(
        param,
        this.jsdata.accId,
        this.jsdata.amount,
        // this.jsdata.transactionCategory,
        this.jsdata.transactionTypeId,
         encodeURIComponent(this.jsdata.comment),
      );
      console.log(res);
      if(res.code==200){
this.$message.success('调整成功')
this.qxsc()
this.biao()
      }else{
       this.$message.error(res.msg)
      }
   },
    async getListAccTransactionType () {
      this.accTransactionTypeList=[]
      await listAccTransactionType().then(r => {
        r.data.data.forEach((zz,zzz)=>{
         
             this.accTransactionTypeList.push(zz)
     
        })
        console.log(  123123123,this.accTransactionTypeList);
        
        // this.accTransactionTypeList = r.data.data
      })
    },
    aaccc (e) {
      console.log(e, this.value1);

    },
    fotmartTime (str) {
      let time = str.replace('T', ' ')
      return time
    },
    async getTypeList () {
      await listAccType().then(r => {
        this.accTypeList = r.data.data
      })
    },
    flstusts (value) {
      let that = this
      let a = that.accTypeList
      let b = ''
      a.forEach(e => {
        if (e.id == value && this.in8l == 'zh') {
          b = e.name
        }
        if (e.id == value && this.in8l !== 'zh') {
          b = e.nameEn
        }

      })
      return b;
    },
    
    formatAccTransactionType (id) {
      let name = ''
      this.accTransactionTypeList.forEach(item => {
        if (item.id == id && this.in8l == 'zh') {
          name = item.name
        }
        if (item.id == id && this.in8l !== 'zh') {
          name = item.nameEn
        }
      })
      return name
    },

    formatType (id) {
      let name = ''
      this.accTypeList.forEach(item => {
        if (item.id == id) {
          name = item.currencyType
        }
      })
      return name
    },

 
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let searchKey = this.formInline.searchKey
     
      const { data: res } = await myAccLis(
        param,
        searchKey,
        
      );

      this.mation = res.data;
    
    },
   
    //搜索
    onSubmit () {
      this.biao();
    },


   
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.topbox {
  display: flex;
  width: 100%;
  // margin-bottom: 20px;
}

.bonntbot {
  // padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;

}

.fs {
  font-size: 28px;
  color: #000;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

.topbox1 {

  font-size: 18px;
  color: #909399;

}
</style>